import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Modal, ModalBody, ModalFooter } from "reactstrap";
import { CopyToClipboard } from "components/copyToClipboard";
import { FREIND_REFERRAL } from "configs/constants";
import { useSelector } from "react-redux";
import { userInfoSelector } from "store/selector/user";
import "assets/styles/components/modal.scss";
import "assets/styles/components/form.scss";

export default function ReferralModal({ setModalOpen, modalOpen }: any) {
  const { t } = useTranslation();
  const { referralToken } = useSelector(userInfoSelector);
  const referralLink = `${FREIND_REFERRAL}+${referralToken}`;

  return (
    <Modal
      toggle={() => setModalOpen(!modalOpen)}
      isOpen={modalOpen}
      centered={true}
      size="lg"
    >
      <Row className="modal-header ">
        <Col xs="2" lg="4">
          <span
            className="icon-close"
            onClick={() => setModalOpen(!modalOpen)}
          ></span>
        </Col>

        <Col xs="10" lg="8">
          <h5 className="modal-title">{t("Invite your friends")}</h5>
        </Col>
      </Row>
      <ModalBody>
        <p className="text-end text-white">
          <Trans i18nKey="Refer_Friends_description">
            By providing your "referral link" or "referral code" to your friends
            and registering through it,
            <span className="text-warning-light">
              30% of the commission of all
            </span>{" "}
            their transactions will be instantly credited to your account.
          </Trans>
        </p>
        <div>
          <Row className="d-flex flex-column align-items-center py-2">
            <Col xs="12" sm="12" md="9">
              <CopyToClipboard
                code={referralLink}
                t={t}
                label={t("Introductory link")}
              />
            </Col>
          </Row>
          <Row className="d-flex flex-column align-items-center py-2">
            <Col xs="12" sm="12" md="9">
              <CopyToClipboard
                t={t}
                code={referralToken}
                label={t("Identifier code")}
              />
            </Col>
          </Row>
        </div>
        <div className="d-flex flex-row-reverse pt-3 ">
          <i className=" icon-warning pt-1" />
          <p className="text-end px-1 text-white">
            {t(
              "Note that the new user must either register through your direct link or enter the identifier code when registering"
            )}
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-between align-items-end w-100">
          <div className="d-flex py-1 ">
            <span className="px-1 text-start">
              {t("Number of your friends: {{number}} people", {
                number: 0,
              })}
            </span>
            <i className="icon-person-add" />
          </div>
          <div className="d-flex align-items-center py-1">
            <span className="px-1">
              {t("Your total profit: {{price}} Tomans", { price: 1 })}
            </span>
            <i className="icon-payments" />
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}
